import { render, staticRenderFns } from "./NewLicensesInfoDlg.vue?vue&type=template&id=18e831c7&scoped=true"
import script from "./NewLicensesInfoDlg.vue?vue&type=script&lang=js"
export * from "./NewLicensesInfoDlg.vue?vue&type=script&lang=js"
import style0 from "./NewLicensesInfoDlg.vue?vue&type=style&index=0&id=18e831c7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e831c7",
  null
  
)

export default component.exports